import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FeatureFlagProvider,
  featureFlagServiceJS,
  MockFeatureFlagService
} from "@ebsco/feature-flag";
import { getFeatureFlagData } from "../../../universal/store/feature-flag";
import getEnabledFeatures from "../../../../src/universal/store/router";

export class FeatureFlagProviderWrapper extends Component {
  constructor(props) {
    super(props);
    this.forceUpdate = this.forceUpdate.bind(this);
    this.renewFeatureFlagService = this.renewFeatureFlagService.bind(this);
    const {
      enabledFeatures,
      isMockFeatureFlagServiceEnabled,
      featureFlagData
    } = this.props;
    if (isMockFeatureFlagServiceEnabled) {
      this.featureFlagService = MockFeatureFlagService.create(enabledFeatures);
      window.__FEATURE_FLAG_SERVICE__ = this.featureFlagService;
      window.__FEATURE_FLAG_SERVICE__.subscribe(this.renewFeatureFlagService); // change value of context provider
      window.__FEATURE_FLAG_SERVICE__.subscribe(this.forceUpdate); // force re-render
    } else {
      this.featureFlagService = featureFlagServiceJS(featureFlagData);
    }
  }

  renewFeatureFlagService() {
    this.featureFlagService = MockFeatureFlagService.create(
      window.__FEATURE_FLAG_SERVICE__.getData()
    );
  }

  componentWillUnmount() {
    if (
      this.props.isMockFeatureFlagServiceEnabled &&
      window.__FEATURE_FLAG_SERVICE__
    ) {
      window.__FEATURE_FLAG_SERVICE__.unsubscribe(this.renewFeatureFlagService);
      window.__FEATURE_FLAG_SERVICE__.unsubscribe(this.forceUpdate);
    }
  }

  render() {
    return (
      <FeatureFlagProvider value={this.featureFlagService}>
        {this.props.children}
      </FeatureFlagProvider>
    );
  }
}

const mapStateToProps = state => ({
  isMockFeatureFlagServiceEnabled: state.isMockFeatureFlagServiceEnabled,
  featureFlagData: getFeatureFlagData(state),
  enabledFeatures: getEnabledFeatures(state)
});

export default connect(mapStateToProps)(FeatureFlagProviderWrapper);
